import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
  relative: {
    position: "relative",
  },
  containerLeftAndTop: {
    right: "0",
    top: "1.625rem",
  },
  container: {
    backgroundColor: "white",
    border: "1px solid #d9e7f0",
    borderRadius: "8px",
    position: "absolute",
    width: "16rem",
    display: "flex",
    zIndex: 100,
  },
  title: {
    fontSize: theme.typography.pxToRem(14),
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    border: "none",
    marginLeft: "-0.75rem",
    "&.MuiInput-underline .MuiInputBase-input": {
      padding: "0.5rem 1.75rem 0.5rem 0.75rem",
      borderRadius: "1rem",
    },
    "&.MuiInput-underline .MuiInputBase-input:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
    "&.MuiInput-underline .MuiSelect-icon": {
      margin: "-1px 3px 0 0",
    },
    "&.MuiInput-underline:hover:not(.Mui-disabled):before": {
      display: "none",
    },
    "&.MuiInput-underline:before": {
      display: "none",
    },
    "&.MuiInput-underline:after": {
      display: "none",
    },
  },
  hiddenMenuItem: {
    display: "none",
  },
  titleContainer: {
    display: "flex",
  },
  controlIcon: {
    height: "16px",
  },
  header: {
    backgroundColor: "#F1F5F9",
    margin: "0 0 20px",
    padding: "10px 4px 2px 20px",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
  },
  controlButton: {
    width: "2.5rem",
    height: "2.5rem",
    flex: 0,
  },
  calendar: {
    width: "100%",
    justifyContent: "space-between",
    display: "flex",
    padding: "0 12px",
    textAlign: "center",
  },
  footer: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    padding: "4px 0 16px",
  },
  current: {
    border: "1px solid black",
  },
  selected: {
    "&:hover": {
      backgroundColor: "#00A3A3",
      color: "white",
    },
    backgroundColor: "#00A3A3",
    color: "white",
  },
  isWeekSelected: {
    backgroundColor: "#E9FBF8",
  },
  weekDay: {
    marginBottom: "10px",
    width: "30px",
    height: "75%",
    fontSize: theme.typography.pxToRem(14),
  },
  day: {
    borderRadius: "100%",
    width: "30px",
    height: "75%",
    fontSize: theme.typography.pxToRem(14),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  applyButton: {
    borderRadius: "100px",
    color: "white",
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
    padding: "8px 24px",
    backgroundColor: "#0344DC",
    "&:hover": {
      backgroundColor: "#0344DC",
      color: "white",
    },
    "&.Mui-disabled": {
      backgroundColor: "lightgray",
    },
  },
}));
